import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsDesktop = (
  slug,
  dispatch,
  translate,
  updateProfessionGroupStatus,
  handleSortChange,
  setProfessionGroupId,
  setShowDeleteConfirmation,
  setProfessionGroupName,
  setSelectedProfessionCount,
  hasAccessToEdit,
  openEditSidePanelModal
) => {
  return [
    // {
    //   Header: "#",
    //   id: "index",
    //   accessor: (_row, i) => {
    //     // Adjust the index based on the page and pageSize
    //     const adjustedIndex = (page - 1) * pageSize + i + 1;
    //     return (
    //       <Text
    //         overflow="hidden"
    //         whiteSpace="nowrap"
    //         fontSize="sm"
    //         color={textSecondary}
    //         fontWeight="500"
    //       >
    //         {adjustedIndex}
    //       </Text>
    //     );
    //   },
    // },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("serviceGroup.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      width: 420,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        return (
          <HStack gap={2}>
            <Stack gap={0} width="350px">
              <Text
                fontSize="15px"
                color={textPrimary}
                textAlign="left"
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxWidth="360px"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },
    // {
    //   Header: translate("serviceGroup.columnCustomId"),
    //   accessor: (row) => {
    //     const { customId } = row;
    //     return (
    //       <Text
    //         overflow="hidden"
    //         whiteSpace="nowrap"
    //         fontSize="sm"
    //         color={textSecondary}
    //       >
    //         {customId}
    //       </Text>
    //     );
    //   },
    // },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("professionCount")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>
              {translate("professionGroup.columnProfessionCount")}
            </Text>
          </Flex>
        </Box>
      ),
      accessor: "professionCount",
      width: 180,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { professionCount } = row.original;

        if (!professionCount) {
          return (
            <Text
              maxWidth="10px"
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
            >
              0
            </Text>
          );
        }

        return (
          <Text
            maxWidth="10px"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="sm"
            color={textSecondary}
            fontWeight="500"
          >
            {professionCount}
          </Text>
        );
      },
    },
    // {
    //   Header: () => (
    //     <Box onClick={() => handleSortChange("defaultRolePermission")}>
    //       <Flex align="center" cursor="pointer">
    //         <Text mr={2}>
    //           {translate("professionGroup.columnDefaultRolePermission")}
    //         </Text>
    //       </Flex>
    //     </Box>
    //   ),
    //   accessor: "defaultRolePermission",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { defaultRolePermission } = row.original;

    //     return (
    //       <HStack gap={2}>
    //         <Stack gap={0} maxWidth="350px" overflow="hidden">
    //           <Text
    //             fontSize="sm"
    //             color={textSecondary}
    //             fontWeight="500"
    //             isTruncated // This will add ellipsis
    //             noOfLines={1} // This will limit the text to two lines
    //             whiteSpace="nowrap"
    //             overflow="hidden"
    //             w="100%"
    //             maxWidth="100%"
    //           >
    //             {translate(`rolePermission.${defaultRolePermission}`)}
    //           </Text>
    //         </Stack>
    //       </HStack>
    //     );
    //   },
    // },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id, name, professions, professionCount } =
          row.original;

        // console.log("row", row.original);

        const hasProfessions = professions && professions.length > 0;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateProfessionGroupStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              p="0 2.5rem"
              isUnclickable={!hasAccessToEdit}
            />
            <MoreButtonLite
              id={_id}
              viewHandler={() => {
                setProfessionGroupId(_id); // Set the profession group ID for viewing
                openEditSidePanelModal();
              }}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setProfessionGroupId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setSelectedProfessionCount(professionCount);
                setProfessionGroupName(row.original.name);
              }}
            />
          </HStack>
        );
      },
    },
  ];
};
